import React from "react";

import ReduxModal from "components/react-lib/generic-ui/modals/ReduxModal";
import { modalsActions } from "store/react-lib/generic-ui/modals";
import { useDispatch } from "react-redux";
import AttachFileForm from "./AttachFileForm";

export default function AttachFileModal({
  title = "Attatch Data to Conversation",
  name = "attachFileModal",
  successCallback = ({ fileId, fileData }) => {},
}) {

  const dispatch = useDispatch();

  const callback = ({ fileId, fileData }) => {
    dispatch(modalsActions.closeModal("attachFileModal"));
    successCallback({ fileId, fileData });
  };

  return (
    <ReduxModal
      name={name}
      title={title}
      fullWidth
      maxWidth="sm"
      closeButtonProps={{
        variant: "outlined",
        color: "text",
      }}
    >
      <AttachFileForm 
        successCallback={callback}
      />
    </ReduxModal>
  );
  
}
